module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="forgot-password-view">\n    <div class="forgot-password-view-inner">\n        <div class="main-logo"></div>\n        <h4>Forgot your password?</h4>\n        <h6>No problem! Enter the email address that you use for Creator and<br>\n            we will send you instructions on how to reset your password.</h6>\n\n        <div class="inner-container">\n            <form class="forgot-form">\n                <div class="control-group">\n                    <input type="text" name="email" class="login-field email-input" placeholder="Email address" autocapitalize="off" autofocus> </br>\n                    <a href="#" class="back-home" tabindex="-1">&lt; Back to sign in page</a>\n                </div>\n                <button class="sign-in-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right">\n                    <span class="ladda-label">Send</span>\n                </button>\n\n                <div class="throttle-region"></div>\n\n                <h6 class="send-success">\n                    <strong>Instructions have been sent.</strong><br>\n                    If you don’t receive an email from us it is most likely because we could not match your email address\n                    with an active Creator user account.\n                    ';
 if (config.supportEmail) { ;
__p += '\n                    If so, please contact <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a> for help.\n                    ';
 } ;
__p += '\n                </h6>\n            </form>\n        </div>\n\n        <footer>\n            ';
 if (config.supportEmail) { ;
__p += '\n            <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n            ';
 } ;
__p += '\n\n            <div class="default-footer"></div>\n        </footer>\n    </div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/user/ForgotPasswordView.tpl
// module id = 2799
// module chunks = 0